export const urls = {
  chatPage: (chatId: string) => `/chat/${chatId}`,
};
